@use "../../styles/breakpoint.module.scss" as *;

.root {
    position: relative;
}

.overlay {
    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: var(--overlay-black-20);
        pointer-events: none;
    }
}

.content {
    padding-bottom: var(--spacer-56);
}

// not using --spacer token because the solution requires what's here
.contentWithDots {
    padding-bottom: 64px;

    @media ($below-mobile) {
        padding-bottom: 56px;
    }
}

.slide {
    width: 100%;
    vertical-align: top;
}

.pauseButton {
    composes: outline from "../../styles/composable/utility.module.css";
    position: absolute;
    z-index: 10;
    bottom: var(--spacer-24);
    right: var(--spacer-24);
    width: 48px;
    height: 48px;
    fill: var(--white);
}
